import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { localesReducerName } from 'store/locales/reducer';
import { RootState } from 'store/rootReducer';

import LoadingLocalesPlaceholder from './LoadingLocalesPlaceholder.layout';
import { LoadingLocalesPlaceholderOwnProps, LoadingLocalesPlaceholderStateProps } from './LoadingLocalesPlaceholder.types';


const mapStateToProps = (state: RootState): LoadingLocalesPlaceholderStateProps => ({
    isLoadingLanguage: state[localesReducerName].isLoadingLanguage,
    isLoadingNamespaces: state[localesReducerName].isLoadingNamespaces,
    //
});

const decorate = compose<ComponentType<LoadingLocalesPlaceholderOwnProps>>(
    withTranslation('common'),
    connect(mapStateToProps),
);
export default decorate(LoadingLocalesPlaceholder);
